import { NodeId, nodesFlux, useEditorSelector } from '@candulabs/craft';
import { useMemo } from 'react';

export const useNodeExists = (id: NodeId) => {
  const selector = useMemo(() => nodesFlux.selectors.doesNodeExist(id), [id]);

  return useEditorSelector(selector);
};
